import { faBars } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import Icon from '../../../components/Icon';
import Badge from '@mui/material/Badge';
import { BsBellFill } from "react-icons/bs";
import { Link, useNavigate } from 'react-router-dom';
import api from '../../../api';

export default function Header({ toggleSideBar }) {
    const [totalPendingCount, setTotalPendingCount] = useState(0);
    const navigate = useNavigate();

    const fetchPendingCounts = async () => {
        try {
            const token = localStorage.getItem("authToken");
            const { data } = await api.get(`${process.env.REACT_APP_API_BASE_URL}admin/pending-counts`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const { studentCount, collegeCount, reportCount } = data;
            const total = studentCount + collegeCount + reportCount;
            setTotalPendingCount(total);
        } catch (error) {
            console.error("Error fetching total pending counts", error);
        }
    };

    useEffect(() => {
        fetchPendingCounts();
    }, []);

    const logout = () => {
        localStorage.removeItem("authToken");
        navigate('/admin/login');
    };

    return (
        <header className="flex items-center justify-between backdrop-blur-md bg-white/10 border-b border-white/10 px-4 py-3 md:px-6 z-10 sticky top-0 text-white">
            {/* Sidebar Toggle */}
            <button onClick={toggleSideBar} className="text-white hover:text-gray-300 transition">
                <Icon icon={faBars} className="w-4 h-4" />
            </button>

            {/* Right Controls */}
            <div className="flex items-center space-x-4">
                <Link to="pending-requests" className="relative">
                    <Badge color="error" badgeContent={totalPendingCount} showZero>
                        <BsBellFill className="w-5 h-5 text-white hover:text-red-400 transition" />
                    </Badge>
                </Link>

                <button
                    onClick={logout}
                    className="bg-red-600/20 hover:bg-red-600/30 text-red-300 px-4 py-2 rounded-full text-xs sm:text-sm transition"
                >
                    Logout
                </button>
            </div>
        </header>
    );
}